import(/* webpackMode: "eager", webpackExports: ["NotFoundLink"] */ "/codebuild/output/src2521049689/src/apps/web/app/[locale]/NotFoundLink.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2521049689/src/node_modules/@mui/material/Alert/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2521049689/src/node_modules/@mui/material/AlertTitle/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2521049689/src/node_modules/@mui/material/Container/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2521049689/src/node_modules/@mui/material/Stack/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2521049689/src/node_modules/@mui/material/Typography/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2521049689/src/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
